import {
    GET_CUSTOMER_NUMBERS,
    GET_CUSTOMER_NUMBERS_SUCCESS,
    GET_OFFERS_SENT_STAT,
    GET_OFFERS_SENT_STAT_SUCCESS,
    GET_OVERVIEW_NUMBERS,
    GET_OVERVIEW_NUMBERS_SUCCESS,
    GET_PRODUCTS_LISTED_STAT,
    GET_PRODUCTS_LISTED_STAT_SUCCESS,
  } from "../../actions/ecommerce/types";
  
  const initialState = {
    numbers: { totalVisits: 0, detailClick: 0, offersSent: 0, productsViewed: 0 },
    numbersLoading: false,
  };
  
  export const customer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_CUSTOMER_NUMBERS:
        return {
          ...state,
          numbersLoading: true,
        };
      case GET_CUSTOMER_NUMBERS_SUCCESS:
        return {
          ...state,
          numbersLoading: false,
          numbers: payload,
        };
  
     
      default: {
        return state;
      }
    }
  };
  